// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding: 24px;
}

.dashboard-header {
  margin-bottom: 32px;
}

.dashboard-header h2 {
  margin-bottom: 8px;
  color: #262626;
}

.dashboard-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.dashboard-error {
  padding: 40px;
  display: flex;
  justify-content: center;
}

.stats-row {
  margin-bottom: 32px;
}

.stat-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.stat-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.stat-card .ant-statistic-title {
  color: #666;
  font-weight: 500;
  margin-bottom: 8px;
}

.stat-card .ant-statistic-content {
  display: flex;
  align-items: center;
}

.stat-icon {
  font-size: 24px;
  margin-right: 8px;
  padding: 8px;
  border-radius: 8px;
  background: rgba(24, 144, 255, 0.1);
}

.stat-icon.apps {
  color: #1890ff;
  background: rgba(24, 144, 255, 0.1);
}

.stat-icon.categories {
  color: #52c41a;
  background: rgba(82, 196, 26, 0.1);
}

.stat-icon.ratings {
  color: #faad14;
  background: rgba(250, 173, 20, 0.1);
}

.stat-icon.views {
  color: #722ed1;
  background: rgba(114, 46, 209, 0.1);
}

.content-row {
  margin-bottom: 24px;
}

.content-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  height: 400px;
}

.content-card .ant-card-head {
  border-bottom: 1px solid #f0f0f0;
  padding: 16px 24px;
}

.content-card .ant-card-head-title {
  font-weight: 600;
  color: #262626;
}

.content-card .ant-card-body {
  padding: 0;
  height: calc(100% - 57px);
  overflow-y: auto;
}

.popular-apps,
.recent-apps {
  padding: 16px 24px;
}

.popular-app-item,
.recent-app-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
  transition: all 0.3s ease;
}

.popular-app-item:last-child,
.recent-app-item:last-child {
  border-bottom: none;
}

.popular-app-item:hover,
.recent-app-item:hover {
  background: #fafafa;
  margin: 0 -24px;
  padding-left: 24px;
  padding-right: 24px;
}

.app-rank {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  margin-right: 16px;
  flex-shrink: 0;
}

.app-info {
  flex: 1 1;
  min-width: 0;
}

.app-name {
  font-weight: 500;
  color: #262626;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-stats {
  color: #666;
  font-size: 12px;
}

.app-stats .anticon {
  margin-right: 4px;
}

.app-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #999;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 16px;
  }
  
  .dashboard-header {
    margin-bottom: 24px;
  }
  
  .stats-row {
    margin-bottom: 24px;
  }
  
  .content-card {
    height: auto;
    min-height: 300px;
  }
  
  .popular-app-item:hover,
  .recent-app-item:hover {
    margin: 0 -16px;
    padding-left: 16px;
    padding-right: 16px;
  }
  
  .popular-apps,
  .recent-apps {
    padding: 16px;
  }
  
  .app-rank {
    width: 28px;
    height: 28px;
    font-size: 12px;
    margin-right: 12px;
  }
  
  .app-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

@media (max-width: 576px) {
  .dashboard-container {
    padding: 12px;
  }
  
  .stat-card .ant-statistic-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .stat-icon {
    margin-right: 0;
    margin-bottom: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".dashboard-container {\n  padding: 24px;\n}\n\n.dashboard-header {\n  margin-bottom: 32px;\n}\n\n.dashboard-header h2 {\n  margin-bottom: 8px;\n  color: #262626;\n}\n\n.dashboard-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.dashboard-error {\n  padding: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.stats-row {\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s ease;\n  border: 1px solid #f0f0f0;\n}\n\n.stat-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.stat-card .ant-statistic-title {\n  color: #666;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.stat-card .ant-statistic-content {\n  display: flex;\n  align-items: center;\n}\n\n.stat-icon {\n  font-size: 24px;\n  margin-right: 8px;\n  padding: 8px;\n  border-radius: 8px;\n  background: rgba(24, 144, 255, 0.1);\n}\n\n.stat-icon.apps {\n  color: #1890ff;\n  background: rgba(24, 144, 255, 0.1);\n}\n\n.stat-icon.categories {\n  color: #52c41a;\n  background: rgba(82, 196, 26, 0.1);\n}\n\n.stat-icon.ratings {\n  color: #faad14;\n  background: rgba(250, 173, 20, 0.1);\n}\n\n.stat-icon.views {\n  color: #722ed1;\n  background: rgba(114, 46, 209, 0.1);\n}\n\n.content-row {\n  margin-bottom: 24px;\n}\n\n.content-card {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid #f0f0f0;\n  height: 400px;\n}\n\n.content-card .ant-card-head {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 16px 24px;\n}\n\n.content-card .ant-card-head-title {\n  font-weight: 600;\n  color: #262626;\n}\n\n.content-card .ant-card-body {\n  padding: 0;\n  height: calc(100% - 57px);\n  overflow-y: auto;\n}\n\n.popular-apps,\n.recent-apps {\n  padding: 16px 24px;\n}\n\n.popular-app-item,\n.recent-app-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #f5f5f5;\n  transition: all 0.3s ease;\n}\n\n.popular-app-item:last-child,\n.recent-app-item:last-child {\n  border-bottom: none;\n}\n\n.popular-app-item:hover,\n.recent-app-item:hover {\n  background: #fafafa;\n  margin: 0 -24px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.app-rank {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n\n.app-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.app-name {\n  font-weight: 500;\n  color: #262626;\n  margin-bottom: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.app-stats {\n  color: #666;\n  font-size: 12px;\n}\n\n.app-stats .anticon {\n  margin-right: 4px;\n}\n\n.app-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n}\n\n.empty-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  color: #999;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 16px;\n  }\n  \n  .dashboard-header {\n    margin-bottom: 24px;\n  }\n  \n  .stats-row {\n    margin-bottom: 24px;\n  }\n  \n  .content-card {\n    height: auto;\n    min-height: 300px;\n  }\n  \n  .popular-app-item:hover,\n  .recent-app-item:hover {\n    margin: 0 -16px;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  \n  .popular-apps,\n  .recent-apps {\n    padding: 16px;\n  }\n  \n  .app-rank {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n    margin-right: 12px;\n  }\n  \n  .app-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n}\n\n@media (max-width: 576px) {\n  .dashboard-container {\n    padding: 12px;\n  }\n  \n  .stat-card .ant-statistic-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .stat-icon {\n    margin-right: 0;\n    margin-bottom: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
